import { request } from '../request';

/**
 * 获取数据中心列表
 *
 * @returns
 */
export const fetchPostDataCenterList = () => {
  return request<Api.Customers.DataCenter[]>({
    url: '/developer-platform/api/dataCenter/list',
    method: 'post'
  });
};

/**
 * 获取跨数据中心访问凭证接口
 *
 * @returns
 */
export const fetchPostAuthToken = () => {
  return request<string>({
    url: '/developer-platform/api/auth/token',
    method: 'get'
  });
};

/**
 * 获取静态词条多语言
 *
 * @returns
 */
export const fetchGetLanguageList = () => {
  return request({
    url: '/developer-platform/api/user/language/code/list',
    method: 'get'
  });
};
